import React from 'react';

import { FallbacksEditor } from '@candu-ai/editor-nodes/collection-settings';
import { useMultiNodes } from 'craft/hooks';
import { CollectionTargetLocation } from 'craft/types';

interface CollectionFieldFallbacksProps {
  nodeIds: string[];
  sortOrder: CollectionTargetLocation[];
  isPopover?: boolean;
}

export const CollectionFallbacksEditor = ({
  nodeIds,
  sortOrder,
  isPopover,
}: CollectionFieldFallbacksProps) => {
  const {
    collections,
    actions: { setCustom },
  } = useMultiNodes(nodeIds, (node) => ({ collections: node?.data?.custom?.collections }));

  return (
    <FallbacksEditor
      context={{ isPopover }}
      collections={collections}
      setCustom={setCustom}
      nodeIds={nodeIds}
      sortOrder={sortOrder}
    />
  );
};
